// sbu-more-rails — fills the book page's "More by …" rails (snippets/sbu-more-rails.liquid).
// Each rail names a URL plus `sections=sbu-related-rail`; this fetches them in page
// order, drops the current book and books an earlier rail already shows, keeps 12,
// and unhides a rail only when a book is left. No @theme imports, no Horizon hooks.
const MAX = 12;

const handleOf = (a) => {
  const m = a && a.getAttribute('href') && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : '';
};

class SbuMoreRails extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    // The host is display:contents (the rails stay flex items of the page
    // column), so it has no box to observe; load once the page is idle.
    const go = () => this.load().catch(() => {});
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2000 });
    else setTimeout(go, 200);
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  async load() {
    const seen = new Set([this.dataset.current]);
    document.querySelectorAll('.sbu-product__set:not(.sbu-more-rails__rail) [data-sbu-rail] a[href*="/products/"]')
      .forEach((a) => seen.add(handleOf(a)));

    for (const rail of this.querySelectorAll('[data-sbu-more-src]')) {
      const url = rail.dataset.sbuMoreSrc;
      // No Accept: application/json header: with it Shopify answers the collection's
      // own JSON instead of the sections payload (measured 2026-10-06).
      const res = await fetch(url, { signal: this.abort.signal });
      if (!res.ok) continue;
      const json = await res.json();
      const html = json && json['sbu-related-rail'];
      if (!html) continue;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const host = doc.querySelector('sbu-shelf-rail');
      const list = host && host.querySelector('[data-sbu-rail]');
      if (!list) continue;
      list.querySelectorAll('script').forEach((s) => s.remove());
      let kept = 0;
      list.querySelectorAll('[data-sbu-handle]').forEach((li) => {
        const h = li.dataset.sbuHandle;
        if (seen.has(h) || kept >= MAX) { li.remove(); return; }
        seen.add(h);
        kept += 1;
      });
      if (kept === 0) continue;
      const slot = rail.querySelector('.sbu-more-rails__slot');
      slot.replaceChildren(document.importNode(host, true));
      rail.hidden = false;
      const ul = slot.querySelector('[data-sbu-rail]');
      if (ul && typeof window.sbuRailSpread === 'function') window.sbuRailSpread(ul);
    }
  }
}

if (!customElements.get('sbu-more-rails')) customElements.define('sbu-more-rails', SbuMoreRails);
